export default "__VITE_ASSET__BKD8Lenk__"